import React from 'react';
import { css } from 'emotion';
import { Footer } from 'client/components/Footer';
import {
  BrandPartners,
  Glossary,
  SellingPoints,
  FAQ,
} from 'client/screens/AdsByAnchorScreen/components';
import { MarketingHeaderBackground } from 'client/components/MarketingPagesShared/MarketingHeaderBackground';
import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { PODCAST_COLORS } from 'client/utils';
import { hexToRgb, rgbToRgbaString } from 'client/modules/ColorUtils';

const headerColor = rgbToRgbaString(hexToRgb(COLOR_GREEN)!);

export function AdsByAnchorScreen() {
  return (
    <>
      <MarketingHeaderBackground color={headerColor} />
      <main
        className={css`
          background-color: ${PODCAST_COLORS.WHITE.color};
        `}
      >
        <section>
          <h1>Ads by Anchor</h1>
        </section>
        <section
          className={css`
            padding: 132px 24px;
            text-align: center;
          `}
        >
          <SellingPoints />
        </section>
        <section>
          <h2>Ads by Anchor overview</h2>
        </section>
        <section>
          <h2>Ways to earn with Anchor</h2>
        </section>
        <section>
          <figure>
            <blockquote>
              Anchor makes it so easy to make money of my podcast with it&#39;s
              wide range of monetization options.
            </blockquote>
            <figcaption>
              Colin, co-host of{' '}
              <cite>&quot;The Colin and Samir Show&quot;</cite>
            </figcaption>
          </figure>
        </section>
        <section
          className={css`
            background-color: ${COLOR_GREEN};
            padding: 0 24px;
          `}
        >
          <BrandPartners />
        </section>
        <section>
          <h2>See how much you could earn</h2>
        </section>
        <section
          className={css`
            padding: 150px 24px;
          `}
        >
          <FAQ />
        </section>
        <section
          className={css`
            background-color: ${COLOR_GREEN};
            color: #fff;
            padding: 132px 24px;
          `}
        >
          <Glossary />
        </section>
      </main>
      <Footer />
    </>
  );
}
